export const CAMPO_OBRIGATORIO = "Campo obrigatório."